// extracted by mini-css-extract-plugin
module.exports = {"avatar-container":"style_avatar-container__2Qls7","contacts-list":"style_contacts-list__3gSNv"};